/**
 * Selects the ad and the saleBanner picture, if any from the state passed
 * @param {Object} state
 * @param {Boolean} isSalePage
 * @returns {Object} { loading: boolean, ad: Object, saleBanner: Object }
 */
export default function getContent(state, isSalePage = false) {
    const { response, error, loading } = state.daz.content;
    if (response === null || error) {
        return null;
    }

    const abovePlacement = response?.body?.placements?.find(({ name }) => name === 'above')?.content;

    const bannerToShow = abovePlacement?.filter((banner) => banner.layoutVariant === `yos-daz-${isSalePage ? 'sale-' : ''}banner`)?.[0];

    // Default to first banner if no layoutVariant matches (eg. for MRP)
    const { media = [], ynapParameter } = bannerToShow || abovePlacement?.[0] || {};

    return {
        loading,
        ad: response?.body?.placements?.find(({ name }) => name === 'main')?.content?.[0],
        bannerLink: ynapParameter,
        banners: media,
    };
}
